import { useIsDesktop } from "common/MediaQueries"
import ModelAndDetailing from "common/ModelAndDetailing"
import ThreeSixtyWrapper from "components/shopFeatures/color/ThreeSixtyWrapper"
import { useEffect, useMemo } from "react"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import ColorSidebar from "./ColorSidebar"
import ThreeSixtyIcon from "./ThreeSixtyIcon"
import { selectedColorSelector } from "./colorSelectors"
import { setLoading, setSelectedColor } from "./colorSlice"

const totalFrames = 24

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-self: stretch;
  align-items: center;
`

const StyledThreeSixtyIcon = styled(ThreeSixtyIcon)`
  position: absolute;
  left: calc(50% - 27px / 2);

  width: 27px;
`

const ColorPage = () => {
  const selectedColor = useTypedSelector(selectedColorSelector)
  const { colors } = useTypedSelector((state) => state.color)
  const isDesktop = useIsDesktop()

  const dispatch = useAppDispatch()

  const images = useMemo(() => {
    if (!selectedColor) return
    dispatch(setLoading(false))

    const _images = selectedColor.details.images.map((i) => i.imageUrl)

    return _images.length === totalFrames
      ? _images
      : [
          ..._images,
          ...Array<string>(totalFrames - _images.length).fill(_images[0]),
        ]
  }, [selectedColor])

  // On mount, if there's no selected color, select the first one
  useEffect(() => {
    if (selectedColor || colors.length === 0) return

    dispatch(setSelectedColor(colors[0].details.code))
  }, [selectedColor, dispatch, colors])

  if (!selectedColor) return null

  return (
    <StyledContainer>
      <ModelAndDetailing />
      <ThreeSixtyWrapper
        imageList={images}
        selectedColorCode={selectedColor?.details?.code}
        allEagerLoading
      />
      {!isDesktop ? <ColorSidebar /> : <StyledThreeSixtyIcon />}
    </StyledContainer>
  )
}

export default ColorPage
